/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Meta_DescInputs */

const en_mk_meta_desc = /** @type {(inputs: Mk_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep turns an idea or a codebase into a PRD, tasks and pass/fail criteria, then runs a closed agent loop: packet → verify → evidence gate → checkpoint. No evidence, no done.`)
};

const id_mk_meta_desc = /** @type {(inputs: Mk_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep mengubah ide atau codebase jadi PRD, task, dan kriteria lulus/gagal, lalu menjalankan loop agent tertutup: packet → verify → gerbang bukti → checkpoint. Tanpa bukti, belum selesai.`)
};

/**
* | output |
* | --- |
* | "Bystep turns an idea or a codebase into a PRD, tasks and pass/fail criteria, then runs a closed agent loop: packet → verify → evidence gate → checkpoint. No ..." |
*
* @param {Mk_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_meta_desc = /** @type {((inputs?: Mk_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_meta_desc(inputs)
	return en_mk_meta_desc(inputs)
});